/**
 * GUERLAIN specific configuration.
 *
 * This will be merged with `src/config/index.ts`
 */

import customerDataForm from "../guerlain/forms/customerData";
import customerConsentForm from "../guerlain/forms/customerConsent";
import customerAdditionalInfo from "../guerlain/forms/customerAdditionalInfo";
import advisorForm from "../guerlain/forms/advisorForm";
import { isProd } from "../../utils/stage";
import debug from "../../utils/debug";

const supportedLanguages = ["en", "fr", "en-CA", "fr-CA"];
debug("env:", {
  appStage: process.env.REACT_APP_STAGE,
  sfEnv: process.env.REACT_APP_SALESFORCE_ENV,
  isProd
});
const loginUrl =
  process.env.REACT_APP_SALESFORCE_ENV &&
  process.env.REACT_APP_SALESFORCE_ENV === "dev"
    ? "https://test.salesforce.com"
    : isProd ||
      window.location.host === "ddc.fr.guerlain.clienteling.lvmhda.com"
    ? "https://login.salesforce.com"
    : "https://test.salesforce.com";

export default {
  id: "guerlain-fr",
  api: "/ddc/v0",
  defaultZone: "europe",
  languages: {
    supportedLanguages,
    loadPath:
      "https://src-guerlain.secure.force.com/digitalcard/services/apexrest/ddcpub/v0/translations/{{lng}}/{{ns}}"
  },
  services: {
    sfdc: {
      Auth: {
        loginUrl: loginUrl,
        proxyUrl: "https://node-salesforce-proxy.herokuapp.com/proxy/"
      }
    },
    api: {
      //baseUrl: BACKEND_BASE_URL,
      getConfigEndpoint: "/ddc/sf/config",
      verifyAdvisorEndpoint: "/ddc/sf/person"
    }
  },
  zones: {
    ca: {
      languages: supportedLanguages,
      supportedLanguages
    },
    fr: {
      languages: supportedLanguages,
      supportedLanguages
    }
  },
  customise: {
    customer: {
      enableAdvisorForm: false
    },
    fields: {
      markRequiredWithSymbol: "*",
      customFields: ["axis", "franchise", "loyalty"]
    }
  },
  forms: {
    schema: "form/customerFormDefinitions.json",
    fields: [
      "form/customerDataFields.json",
      "form/customerConsentFields.json",
      "form/customerThanks.json",
      "form/additionalInfoFields.json"
    ],
    customer: [
      customerDataForm,
      customerConsentForm,
      customerAdditionalInfo,
      advisorForm
    ]
  }
};
